import { render, staticRenderFns } from "./ArtworkPreviewModal.vue?vue&type=template&id=2f7d12bd&scoped=true"
import script from "./ArtworkPreviewModal.vue?vue&type=script&lang=js"
export * from "./ArtworkPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ArtworkPreviewModal.vue?vue&type=style&index=0&id=2f7d12bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7d12bd",
  null
  
)

export default component.exports